export default __webpack_public_path__ + "static/media/icon_ovm_admin.fa672b44.svg";